


















































import { Component, Vue } from 'vue-property-decorator'
import Pagination from '@/components/Pagination/index.vue'
import { Country } from '@/models/index'
import { IValidationError } from 'spraypaint/lib-esm/validation-errors'

@Component({
  name: 'CountriesTable',
  components: {
    Pagination
  }
})
export default class extends Vue {
  private tableKey = 0
  private list: Country[] = []
  private total = 0
  private listLoading = true
  private listQuery: any = {
    page: 1,
    limit: 20,
    name: undefined
  }

  private async getList() {
    this.listLoading = true

    let scope = Country
      .includes(['regions'])
      .page(this.listQuery.page)
      .per(this.listQuery.limit)
      .order({ name: 'asc' })
      .stats({ total: 'count' })

    if (this.listQuery.name) {
      scope = scope.where({ name: { prefix: this.listQuery.name } })
    }

    const { data, meta } = await scope.all()

    this.list = data
    this.total = meta.stats.total.count
    this.listLoading = false
  }

  private handleFilter() {
    this.listQuery.page = 1
    this.getList()
  }

  private printErrors(errors: any) {
    const e: (IValidationError<Country> | undefined)[] = Object.values(errors)
    for (const error of e) {
      if (error) {
        this.$notify({
          title: error.title,
          message: error.fullMessage,
          type: 'error',
          duration: 5000
        })
      }
    }
  }

  private async handleDelete(data: Country, index: number) {
    await data.destroy()

    if (Object.keys(data.errors).length > 0) {
      this.printErrors(data.errors)
    } else {
      this.$notify({
        title: 'Succès',
        message: 'Pays supprimé avec succès',
        type: 'success',
        duration: 2000
      })
      this.list.splice(index, 1)
      this.total -= 1
    }
  }

  created() {
    this.getList()
  }

  private handleAction(command: any, country: Country) {
    if (command === 'edit') this.$router.push({ name: 'CountryEdit', params: { id: country.id } })
  }
}
